import { Avatar, styled } from '@material-ui/core'
import React, { useEffect, useRef } from 'react'
import "./UserChat.css"

interface IProps {
    user: any,
    isShowTick?: number;
    createDialog?: any;
    getMessagesList?: any[];
    QB?: any;
    testId?: string;
    isSelectedUser?: boolean;
    isEmailSelected?: string;
    clickedSelectedUser?: string;
    emailData?: string;
    userIndex?: number;
    selectedQuickBloxId?: string;
    userProfile?: any
}

export const UserChat: React.FC<IProps> = (props) => {
    const { user, isShowTick, createDialog, getMessagesList, testId, isEmailSelected, selectedQuickBloxId, isSelectedUser, userProfile} = props

    const userBgRef = useRef<any>(null)
    useEffect(() => {
        if (!userBgRef.current) return;
        if(userBgRef.current.id == selectedQuickBloxId) {
            userBgRef.current.classList.add("user-active")
        } else {
            userBgRef.current.classList.remove("user-active")
        }
    }, [user, selectedQuickBloxId])

    getMessagesList?.forEach((val: any) => {
        if (val?.recipient_id === user?.user?.id) {
            const formatTime = (dateString: string) => {
                const date = new Date(dateString);
                const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };

                const startTime = new Date(date);
                startTime.setHours(10, 0, 0, 0);
                const endTime = new Date(date);
                endTime.setHours(13, 0, 0, 0);

                const formattedTime = (date >= startTime && date < endTime) ? date.toLocaleTimeString('en-US', options) : "01:00 PM";

                return formattedTime;
            };
        }
    })

    const displayName = user?.patient_id ? String(user.patient_id) : user?.name;
    const unreadCount = Number(user?.unread_messages_count || 0);
    const subtitle = user?.last_message && !String(user.last_message).startsWith("Patient ID:")
        ? user.last_message.substring(0, 40)
        : "";

    const handleSelectedUser = (e: any, userId: string) => {
        createDialog(user, userId, userProfile?.attributes?.profile_image);
        if (userBgRef?.current) {
            const activeUser = document.querySelector('.user-active')
            activeUser?.classList.remove("user-active")
            if (userBgRef.current.id == userId) {
                userBgRef.current.classList.add("user-active")
            }else{  
                userBgRef.current.classList.remove("user-active")
            }
        }
    }


    return (
        <>
            {isShowTick !== 0 ? <UserContainer id={user._id} className='user-bg ' ref={userBgRef} data-testid={testId} style={{ display: 'flex', padding: 16, justifyContent: 'center', alignItems: 'center' }} onClick={(e) => { handleSelectedUser(e, user?._id) }}>
                <Avatar style={{ marginRight: 8 }} alt="Remy Sharp" src={userProfile?.attributes?.profile_image}/>
                <div style={{ flex: 1, }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {unreadCount > 0 ? <UnreadMessageCounterContainer style={{ marginRight: 8 }}>
                            <UnreadMessageCounter>{unreadCount > 99 ? "99+" : unreadCount}</UnreadMessageCounter>
                        </UnreadMessageCounterContainer> : null}
                        <Username style={{ flex: 1, marginBottom: subtitle ? 8 : 0 }}>{displayName}</Username>
                        <ReceivedAt>{user.receivedAt}</ReceivedAt>
                    </div>
                    {subtitle ? <div style={{ display: 'flex' }}>
                        <LastMessage style={{ flex: 1 }}>{subtitle}</LastMessage>
                    </div> : null}
                </div>
            </UserContainer> : <UserContainer id={user?._id} className='user-bg ' ref={userBgRef} data-testid={testId} style={{ display: 'flex', padding: 16, justifyContent: 'center', alignItems: 'center', }} onClick={(e) => { handleSelectedUser(e, user?._id) }}>
                <Avatar style={{ marginRight: 8 }} alt="Remy Sharp" src={userProfile?.attributes?.profile_image}/>
                <div style={{ flex: 1, }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {unreadCount > 0 ? <UnreadMessageCounterContainer style={{ marginRight: 8 }}>
                            <UnreadMessageCounter>{unreadCount > 99 ? "99+" : unreadCount}</UnreadMessageCounter>
                        </UnreadMessageCounterContainer> : null}
                        <Username style={{ flex: 1, marginBottom: subtitle ? 8 : 0 }}>{displayName}</Username>
                        <ReceivedAt>{user.receivedAt}</ReceivedAt>
                    </div>
                    {subtitle ? <div style={{ display: 'flex' }}>
                        <LastMessage style={{ flex: 1 }}>{subtitle}</LastMessage>
                    </div> : null}
                </div>
            </UserContainer>}
        </>
    )
}

export const UserContainer = styled(`div`)({
    transition: 'background-color 0.3s',
    cursor: 'pointer',
    borderRadius: '8px',
    "&:hover": {
        backgroundColor: "#E8EEF5",
    },
})

export const Username = styled(`span`)({
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#1F3650",
})

export const ReceivedAt = styled(`span`)({
    fontSize: 14,
    fontFamily: "Inter",
})



export const UnreadMessageCounterContainer = styled(`div`)({
    width: 20,
    height: 20,
    borderRadius: 10,
    background: "#A046FB",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
})

export const UnreadMessageCounter = styled(`span`)({
    fontSize: 13,
    color: 'white'
})

export const LastMessage = styled(`span`)({
    fontSize: 13,
    color: "#1F3650",
    fontWeight: 600,
    fontFamily: "Inter"
})


